<template>
    <LayoutModal v-model="model">
        <div
            v-click-outside="close"
            class="max-h-screen w-full max-w-xl border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col"
        >
            <div class="flex-shrink-0 flex items-center p-4 sm:p-6 space-x-4">
                <p class="text-left flex-grow text-lg font-medium ct-text-1">
                    {{ $t("shared.help.help_community") }}
                </p>
                <ButtonCloseSmXs @click="close" />
            </div>
            <div class="flex-grow overflow-y-auto">
                <HelpOnboarding
                    v-if="showOnboarding"
                    v-model="galleryOpened"
                    @hide="hideOnboarding"
                />
                <div
                    class="px-4 sm:px-6 divide-y divide-y-gray-200 dark:divide-y-neutral-800 overflow-y-auto"
                >
                    <HelpSection
                        v-for="section in sections"
                        :key="section.title"
                        :section="section"
                        @ctaAction="section.action"
                    />
                </div>
            </div>
        </div>
    </LayoutModal>
</template>

<script>
import { i18n } from "@/i18n";
import { LayoutModal } from "@easy/ui/layouts";
import { ButtonCloseSmXs } from "@easy/ui/buttons";
import HelpOnboarding from "./help/HelpOnboarding.vue";
import HelpSection from "./help/HelpSection.vue";
import { openLinkInNewTab } from "@/shared/utils/helpers";

export default {
    components: {
        ButtonCloseSmXs,
        HelpOnboarding,
        HelpSection,
        LayoutModal,
    },
    props: {
        modelValue: Boolean,
    },
    emits: ["update:modelValue"],
    data() {
        return {
            onboardingHideKey: "EC_HIDE_ONBOARDING_HELP",
            showOnboarding: false,
            galleryOpened: false,
            sections: [
                {
                    title: this.$t("shared.help.see_whats_new"),
                    subtitle: this.$t("shared.help.see_whats_new_subtitle"),
                    ctaLabel: this.$t("shared.help.changelog"),
                    ctaIcon: "BulletListIcon",
                    action: this.goToChangelog,
                },
                {
                    title: this.$t("shared.help.academy"),
                    subtitle: this.$t("shared.help.academy_subtitle"),
                    ctaLabel: this.$t("shared.help.academy"),
                    ctaIcon: "LiveVideoIcon",
                    action: this.goToAcademy,
                },
                {
                    title: this.$t("shared.help.help_page"),
                    subtitle: this.$t("shared.help.help_page_subtitle"),
                    ctaLabel: this.$t("shared.help.help_page"),
                    ctaIcon: "BookIcon",
                    action: this.goToDocumentation,
                },
                {
                    title: this.$t("shared.help.slack_community"),
                    subtitle: this.$t("shared.help.slack_community_subtitle"),
                    ctaLabel: this.$t("shared.help.join_our_slack"),
                    ctaIcon: "PrayingHandsIcon",
                    action: this.goToCommunity,
                },
                {
                    title: this.$t("shared.help.report_bug"),
                    subtitle: this.$t("shared.help.report_bug_subtitle"),
                    ctaLabel: this.$t("shared.help.report_bug"),
                    ctaIcon: "",
                    action: this.goToReportBug,
                },
            ],
        };
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    created() {
        if (!localStorage.getItem(this.onboardingHideKey)) {
            this.showOnboarding = true;
        }
    },
    methods: {
        getEasyToolsLink() {
            const lang = i18n.global.locale.value;
            return `https://easy.tools/${lang === "pl" ? "pl/" : ""}`;
        },
        goToChangelog() {
            openLinkInNewTab(`${this.getEasyToolsLink()}changelog`);
        },
        goToAcademy() {
            const lang = i18n.global.locale.value;
            openLinkInNewTab(
                `${this.getEasyToolsLink()}${lang === "pl" ? "materialy" : "resources"}`
            );
        },
        goToDocumentation() {
            const lang = i18n.global.locale.value;
            openLinkInNewTab(
                `${this.getEasyToolsLink()}${lang === "pl" ? "docs/odkrywaj" : "docs/explore"}`
            );
        },
        goToCommunity() {
            openLinkInNewTab("https://go.easy.tools/SgQec0C");
        },
        goToReportBug() {
            openLinkInNewTab("https://airtable.com/appNKcNHn4058Kc0G/pag5V7wPescXKZp0Q/form");
        },
        close() {
            if (this.galleryOpened) {
                return;
            }
            this.model = false;
        },
        hideOnboarding() {
            localStorage.setItem(this.onboardingHideKey, 1);
            this.showOnboarding = false;
        },
    },
};
</script>
